// @flow
const onlyNumbers = /^\d+$/
const onlyLetters = /^[a-zA-Z ]*$/

export default { onlyNumbers, onlyLetters }
